'use strict';

var _ = require('lodash');
var d3 = require('d3');

/**
 * Horizontal range Bars
 *
 * Renders horizontal bars
 *
 * @returns {Function}
 * @constructor
 */
var HorizontalRangeBars = function HorizontalRangeBars() {
  /**
   * @param startPropertyName - a property name used to find X value
   * @returns {Function}
   * @constructor
   */
  return function (startPropertyName, endPropertyName) {
    var params, scales, barHeight;
    var customClass = '';
    var baseClass = 'horizontal-range-bar';
    var shift = 0;
    /**
     *
     * @param container
     */
    var bars = function bars(container) {
      barHeight = barHeight || scales.yScale.rangeBand();
      var group = container.select('.groups').selectAll('.stack.visible');
      group.each(function (d) {
        if (d[startPropertyName] !== undefined && d[endPropertyName] !== undefined) {
          var rangeBars = d3.select(this).selectAll('.' + baseClass).data([d]);
          rangeBars.enter().append('rect');
          rangeBars.attr({
            "class": function _class(d) {
              return _.compact([baseClass, customClass, d.customClass]).join(' ');
            },
            x: function x(d) {
              return scales.xScale(d[startPropertyName]);
            },
            y: shift,
            height: barHeight,
            width: function width(d) {
              var rangeBarWidth = scales.xScale(d[startPropertyName]) - scales.xScale(d[endPropertyName]);
              return rangeBarWidth != 0 ? Math.abs(rangeBarWidth) : 1;
            }
          });
        }
      });
    };

    /**
     *  Setters and getters
     */

    bars.params = function (value) {
      params = value;
      return bars;
    };
    bars.scales = function (value) {
      scales = value;
      return bars;
    };
    bars.withHeight = function (value) {
      barHeight = value;
      return bars;
    };
    bars.withShift = function (value) {
      shift = value;
      return bars;
    };
    bars.withCustomClass = function (value) {
      customClass = value;
      return bars;
    };
    return bars;
  };
};
HorizontalRangeBars.$inject = [];
module.exports = HorizontalRangeBars;